import React, { useEffect, useState } from "react";
import {
  Button as MUIButton,
  IconButton,
  Snackbar,
  Alert,
  Tooltip,
  Dialog,
  DialogTitle,
  AppBar,
  Tabs,
  Tab,
  Paper,
  Card,
  Grid,
} from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import PropTypes from "prop-types";

import CloseIcon from "@mui/icons-material/Close";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { set } from "date-fns";
// import { Table } from "lucide-react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconTableExport } from "@tabler/icons-react";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <MDBox sx={{ p: 3 }}>
          <MDTypography>{children}</MDTypography>
        </MDBox>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  console.log("🚀 ~ a11yProps ~ index:", index);
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function WeeklyReport() {
  const [loadingSubmission, setLoadingSubmission] = useState(false);

  const [message, setMessage] = useState({
    status: "",
    title: "",
    msg: "",
  });

  const [openDialog, setOpenDialog] = useState(false);

  const [rotate, setRotate] = React.useState(0);
  const handleMouseEnter = () => {
    setRotate(360);
  };

  const handleMouseLeave = () => {
    setRotate(180);
  };

  const fetchReportData = async () => {
    try {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/report/weekly-report`,
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });
      // console.log("🚀 ~ fetchUsers ~ response:", response);
      return response.data;
    } catch (error) {
      console.log("🚀 ~ fetchReportData ~ error:", error);
    }
  };

  const {
    data: reportData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["fetchReportData"], // Unique key for the query
    queryFn: fetchReportData, // The async function to run
    retry: false,
  });
  //   console.log("🚀 ~ WeeklyReport ~ reportData:", reportData);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [district, setDistrict] = useState([]);
  const [groupedByDistrict, setGroupedByDistrict] = useState([]);

  useEffect(() => {
    // console.log("🚀 ~ WeeklyReport ~ reportData:", reportData);
    if (reportData) {
      console.log(" :", [...new Set(reportData.data.map((item) => item.district))]);
      setDistrict([...new Set(reportData.data.map((item) => item.district))]);

      const tempGroupedByDistrict = reportData.data.reduce((groups, item) => {
        const key = item.district; // property to group by
        if (!groups[key]) {
          groups[key] = []; // initialize array if it doesn't exist
        }
        groups[key].push(item); // push current object into correct group
        return groups;
      }, {});
      console.log("🚀 ~ WeeklyReport ~ tempGroupedByDistrict:", tempGroupedByDistrict);

      setGroupedByDistrict(tempGroupedByDistrict);
    }
  }, [reportData]);

  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();

    const cellStyles = {
      header: {
        fill: { fgColor: { rgb: "CCCCCC" } },
        font: { bold: true },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
      },
      cell: {
        fill: { fgColor: { rgb: "FFFFFF" } },
        border: {
          top: { style: "thin", color: { rgb: "000000" } },
          bottom: { style: "thin", color: { rgb: "000000" } },
          left: { style: "thin", color: { rgb: "000000" } },
          right: { style: "thin", color: { rgb: "000000" } },
        },
      },
    };

    const setCellStyles = (ws, range, style) => {
      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cell_address = { c: C, r: R };
          const cell_ref = XLSX.utils.encode_cell(cell_address);
          if (!ws[cell_ref]) continue;
          if (!ws[cell_ref].s) ws[cell_ref].s = {};
          ws[cell_ref].s = { ...ws[cell_ref].s, ...style };
        }
      }
    };

    Object.entries(reportData).forEach(([emp_no, items]) => {
      const table = document.getElementById(emp_no);
      const worksheet = XLSX.utils.table_to_sheet(table);

      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      // Apply header styles
      setCellStyles(
        worksheet,
        { s: { r: 0, c: range.s.c }, e: { r: 0, c: range.e.c } },
        cellStyles.header
      );

      // Apply cell styles
      setCellStyles(
        worksheet,
        { s: { r: 1, c: range.s.c }, e: { r: range.e.r, c: range.e.c } },
        cellStyles.cell
      );

      // Handle merged cells
      if (worksheet["!merges"]) {
        worksheet["!merges"].forEach((merge) => {
          setCellStyles(worksheet, merge, cellStyles.cell);
        });
      }

      // Add the worksheet to the workbook with the specified sheet name
      XLSX.utils.book_append_sheet(workbook, worksheet, emp_no);
    });

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Weekly-Report-${moment().format("ddd, DD MMM Y, hh:mm A")}.xlsx`);
  };

  const handleExportData = async () => {
    try {
      debugger;
      const grouped = reportData.data.reduce((acc, row) => {
        acc[row.district] = acc[row.district] || [];
        acc[row.district].push(row);
        return acc;
      }, {});

      const wb = XLSX.utils.book_new();

      Object.entries(grouped).forEach(([district, rows]) => {
        // --- Collect unique titles & weeks inside this district
        const titles = Array.from(new Set(rows.map((r) => r.title)));
        const weeks = Array.from(new Set(rows.map((r) => r.week_range)));

        // --- Build a lookup of totals: title + week
        const totals = {};
        rows.forEach((r) => {
          const key = `${r.title}__${r.week_range}`;
          totals[key] = (totals[key] || 0) + r.total_submissions;
        });

        // --- Prepare array of objects for XLSX (week ranges as keys)
        const sheetData = titles.map((title) => {
          const row = { Title: title };
          weeks.forEach((week) => {
            row[week] = totals[`${title}__${week}`] || 0;
          });
          return row;
        });

        // --- Add to workbook
        const ws = XLSX.utils.json_to_sheet(sheetData);
        const sheetName = district.length > 31 ? district.slice(0, 31) : district;
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      });

      // 4. Write and save
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), "missions.xlsx");

      setMessage({
        status: "success",
        title: "Success",
        msg: "Excel downloaded successfully!",
      });
    } catch (error) {
      console.error("Export error:", error);
      setMessage({
        status: "error",
        title: "Error",
        msg: "Something went wrong during export.",
      });
    }
  };

  return (
    <DashboardLayout>
      <Snackbar
        open={Boolean(message.status)}
        autoHideDuration={3000}
        onClose={() => setMessage({ status: "", title: "", msg: "" })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setMessage({ status: "", title: "", msg: "" })}
          severity={message.status}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message.msg}
        </Alert>
      </Snackbar>

      <Card
        id="delete-account"
        sx={{
          mb: 3,
          // border: "2px solid #2bc29c", // green border
          borderRadius: "10px", // optional, for rounded corners
        }}
      >
        {/* <MDBox mt={3} /> */}
        <MDBox pt={2} px={2} pb={3}>
          <Grid container spacing={1} display={"flex"} alignItems={"center"}>
            <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
              <MDTypography variant="h5" fontWeight="medium">
                Mission Tracker Weekly Report
              </MDTypography>
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, display: "flex", justifyContent: "flex-end" }}>
              <MDTypography variant="h5" fontWeight="medium">
                <MUIButton
                  onClick={handleExportData}
                  sx={{
                    background:
                      "linear-gradient(90deg, rgba(2, 183, 255, 0.65) 30%,rgb(110, 199, 235) 100%)",
                    color: "#f4f4f4",
                    borderRadius: "8px",
                    padding: "10px 20px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                    transition: "background 0.3s, transform 0.3s",
                    "&:hover": {
                      background:
                        "linear-gradient(90deg, rgba(55, 198, 254, 0.97) 30%,rgb(39, 169, 220) 100%))",
                      transform: "scale(1.05)",
                    },
                    "&:active": {
                      transform: "scale(0.95)",
                    },
                  }}
                  startIcon={<IconTableExport />}
                >
                  {"Export To Excel"}
                </MUIButton>
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          {/* <Grid container spacing={3}> */}
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="inherit"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              {district.map((d, index) => (
                <Tab key={d} label={d} {...a11yProps(index)} />
              ))}
            </Tabs>
          </AppBar>

          {district.map((d, index) => {
            const rawData = groupedByDistrict[d];

            const weekRanges = [...new Set(rawData.map((item) => item.week_range))];

            // Get unique titles
            const titles = [...new Set(rawData.map((item) => item.title))];

            // Build a lookup to sum total_submissions by title & week_range
            const dataMap = {};
            rawData.forEach((item) => {
              const key = `${item.title}__${item.week_range}`;
              dataMap[key] = (dataMap[key] || 0) + item.total_submissions;
            });

            return (
              <TabPanel key={d} value={value} index={index}>
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer component={Paper}>
                    <Table id={d} className="min-w-full border-collapse border border-gray-300">
                      <TableHead style={{ display: "table-header-group" }}>
                        <TableRow>
                          <TableCell
                            style={{ background: "#084636", color: "white" }}
                            className="border p-2 text-left bg-gray-100"
                          >
                            Mission
                          </TableCell>
                          {weekRanges.map((week) => (
                            <TableCell
                              style={{ background: "#084636", color: "white" }}
                              key={week}
                              className="border p-2 bg-gray-100"
                            >
                              {week}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {titles.map((title) => (
                          <TableRow key={title}>
                            <TableCell className="border p-2 font-semibold">{title}</TableCell>
                            {weekRanges.map((week) => (
                              <TableCell key={week} className="border p-2 text-center">
                                {dataMap[`${title}__${week}`] || 0}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </TabPanel>
            );
          })}
          {/* </Grid> */}
        </MDBox>
      </Card>
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="md"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: 2,
            boxShadow: 6,
            position: "relative",
            overflow: "visible",
          },
        }}
      >
        <IconButton
          onClick={() => setOpenDialog(false)}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          sx={{
            position: "absolute",
            top: -18,
            right: -16,
            backgroundColor: "#fff",
            color: "#ff0a54",
            boxShadow: 1,
            zIndex: 1500,
            p: 1.5,
            "&:hover": {
              backgroundColor: "#ff0a54",
              color: "#fff",
            },
            transition: "transform 0.5s ease",
            transform: `rotate(${rotate}deg)`,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogTitle
          sx={{
            background: "linear-gradient(45deg, #f48c06, #191919)",
            color: "white !important",
            fontWeight: "bold",
            fontSize: "18px",
            textAlign: "center",
            position: "relative",
            zIndex: 1400,
            py: 2,
          }}
        >
          Submission Details
        </DialogTitle>
      </Dialog>
    </DashboardLayout>
  );
}

const TooltipCell = ({ cell }) => {
  const value = cell?.getValue?.() ?? "";

  // show only first 20 chars in the table cell
  const displayValue = value.length > 20 ? value.substring(0, 20) + "..." : value;

  return (
    <Tooltip title={value}>
      <span>{displayValue}</span>
    </Tooltip>
  );
};

TooltipCell.propTypes = {
  cell: PropTypes.shape({
    getValue: PropTypes.func, // optional func, validated
  }).isRequired,
};
